import { render, staticRenderFns } from "./Tooltips.vue?vue&type=template&id=1c268a96&scoped=true&"
import script from "./Tooltips.vue?vue&type=script&lang=js&"
export * from "./Tooltips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c268a96",
  null
  
)

export default component.exports